import Shift from "app/models/shift"

export interface IPutShiftPayload {
  id: string
  shift: Shift
}
export type TPostShiftPayload = Omit<Shift, "id">

export enum Types {
  GET = "SHIFTS_GET",
  GET_SUCCESS = "SHIFTS_GET_SUCCESS",
  GET_FAIL = "SHIFTS_GET_FAIL",
  POST = "SHIFTS_POST",
  POST_SUCCESS = "SHIFTS_POST_SUCCESS",
  POST_FAIL = "SHIFTS_POST_FAIL",
  PUT = "SHIFTS_PUT",
  PUT_SUCCESS = "SHIFTS_PUT_SUCCESS",
  PUT_FAIL = "SHIFTS_PUT_FAIL",
  DELETE = "SHIFTS_DELETE",
  DELETE_SUCCESS = "SHIFTS_DELETE_SUCCESS",
  DELETE_FAIL = "SHIFTS_DELETE_FAIL",
}

export type Action =
  | GetShiftsAction
  | GetShiftsSuccessAction
  | GetShiftsFailAction
  | PostShiftAction
  | PostShiftSuccessAction
  | PostShiftFailAction
  | PutShiftAction
  | PutShiftSuccessAction
  | PutShiftFailAction
  | DeleteShiftAction
  | DeleteShiftSuccessAction
  | DeleteShiftFailAction

export type GetShiftsAction = {
  type: Types.GET
}

export type GetShiftsSuccessAction = {
  payload: { data: Shift[] | undefined }
  type: Types.GET_SUCCESS
}

export type GetShiftsFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PostShiftAction = {
  type: Types.POST
  payload: TPostShiftPayload
}

export type PostShiftSuccessAction = {
  type: Types.POST_SUCCESS
  payload: Shift
}

export type PostShiftFailAction = {
  type: Types.POST_FAIL
  payload: { errors: object }
}

export type PutShiftAction = {
  type: Types.PUT
  payload: IPutShiftPayload
}

export type PutShiftSuccessAction = {
  type: Types.PUT_SUCCESS
  payload: Shift
}

export type PutShiftFailAction = {
  type: Types.PUT_FAIL
  payload: { errors: object }
}

export type DeleteShiftAction = {
  type: Types.DELETE
  payload: string
}

export type DeleteShiftSuccessAction = {
  type: Types.DELETE_SUCCESS
  payload: string
}

export type DeleteShiftFailAction = {
  type: Types.DELETE_FAIL
  payload: { errors: object }
}

export function getShifts(): GetShiftsAction {
  return {
    type: Types.GET,
  }
}

export function getShiftsSuccess(data: Shift[] | undefined): GetShiftsSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getShiftsFail(errors: object): GetShiftsFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function postShift(payload: PostShiftAction["payload"]): PostShiftAction {
  return {
    type: Types.POST,
    payload,
  }
}

export function postShiftSuccess(payload: PostShiftSuccessAction["payload"]): PostShiftSuccessAction {
  return {
    type: Types.POST_SUCCESS,
    payload,
  }
}

export function postShiftFail(errors: object): PostShiftFailAction {
  return {
    type: Types.POST_FAIL,
    payload: { errors },
  }
}

export function putShift(payload: PutShiftAction["payload"]): PutShiftAction {
  return {
    type: Types.PUT,
    payload,
  }
}

export function putShiftSuccess(payload: PutShiftSuccessAction["payload"]): PutShiftSuccessAction {
  return {
    type: Types.PUT_SUCCESS,
    payload,
  }
}

export function putShiftFail(errors: object): PutShiftFailAction {
  return {
    type: Types.PUT_FAIL,
    payload: { errors },
  }
}

export function deleteShift(payload: DeleteShiftAction["payload"]): DeleteShiftAction {
  return {
    type: Types.DELETE,
    payload,
  }
}

export function deleteShiftSuccess(payload: DeleteShiftAction["payload"]): DeleteShiftSuccessAction {
  return {
    type: Types.DELETE_SUCCESS,
    payload,
  }
}

export function deleteShiftFail(errors: object): DeleteShiftFailAction {
  return {
    type: Types.DELETE_FAIL,
    payload: { errors },
  }
}
